export const FETCH_EXTERNAL_DATA = 'FETCH_EXTERNAL_DATA';


export const fetchExternalData = () => {
  return {
    type: FETCH_EXTERNAL_DATA
  }
}